// @flow
export const AUTH_MODULE_NAME: 'auth' = 'auth';

export const AUTH_ACTION_TYPE: {
    LOGIN_FAIL: 'AUTH__LOGIN_FAIL',
    LOGIN_START: 'AUTH__LOGIN_START',
    LOGIN_SUCCESS: 'AUTH__LOGIN_SUCCESS',
    LOGOUT: 'AUTH__LOGOUT',
    SET_AUTH_USER_COMPANY: 'AUTH__SET_AUTH_USER_COMPANY',
    SET_AUTH_USER_DATA: 'AUTH__SET_AUTH_USER_DATA',
    SET_STATUS_EDUCATION: 'AUTH__SET_STATUS_EDUCATION',
} = {
    LOGIN_FAIL: 'AUTH__LOGIN_FAIL',
    LOGIN_START: 'AUTH__LOGIN_START',
    LOGIN_SUCCESS: 'AUTH__LOGIN_SUCCESS',
    LOGOUT: 'AUTH__LOGOUT',
    SET_AUTH_USER_COMPANY: 'AUTH__SET_AUTH_USER_COMPANY',
    SET_AUTH_USER_DATA: 'AUTH__SET_AUTH_USER_DATA',
    SET_STATUS_EDUCATION: 'AUTH__SET_STATUS_EDUCATION',
};

export const ROLE_DATA = {
    ADMIN: 3,
    GUEST: 1,
    STUDENT: 4,
    SUPER_ADMIN: 2,
};
